module.exports = __webpack_public_path__ + "FondoA3MIA_Widget.png";